/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

/* eslint no-underscore-dangle: 0 */
export const apiBaseUrl = window.__RUNTIME_CONFIG__.API_BASE_URL;

export const stripePublishableKey =
  window.__RUNTIME_CONFIG__.STRIPE_PUBLISHABLE_KEY;

export const asgardeoSdkConfig = {
  ...window.__RUNTIME_CONFIG__.ASGARDEO_SDK_CONFIG,
  scope: window.__RUNTIME_CONFIG__.ASGARDEO_SDK_CONFIG.scope.split(','),
};

export const asgardeoEUSpecificSdkConfig = {
  ...window.__RUNTIME_CONFIG__.ASGARDEO_EU_SPECIFIC_SDK_CONFIG,
  scope:
    window.__RUNTIME_CONFIG__.ASGARDEO_EU_SPECIFIC_SDK_CONFIG.scope.split(','),
};

export const fidpGoogle = window.__RUNTIME_CONFIG__.FIDP_GOOGLE;

export const fidpGitHub = window.__RUNTIME_CONFIG__.FIDP_GITHUB;

export const fidpMicrosoft = window.__RUNTIME_CONFIG__.FIDP_MICROSOFT;

export const enableMicrosoftLogin =
  window.__RUNTIME_CONFIG__.ENABLE_MICROSOFT_LOGIN;

export const asgardeoConsoleUrl =
  window.__RUNTIME_CONFIG__.ASGARDEO_CONSOLE_URL;

export const choreoConsoleUrl = window.__RUNTIME_CONFIG__.CHOREO_CONSOLE_URL;

export const azureInsightsKey = window.__RUNTIME_CONFIG__.AZURE_INSIGHTS_KEY;

export const choreoTierConfig = window.__RUNTIME_CONFIG__.CHOREO_TIER_CONFIG;

export const enableAsgardeo = window.__RUNTIME_CONFIG__.ENABLE_ASGARDEO;

export const enableAsgardeoSelfServiceUpgrade =
  window.__RUNTIME_CONFIG__.ENABLE_ASGARDEO_SELF_SERVICE_UPGRADE;

export const enableAsgardeoV2 = window.__RUNTIME_CONFIG__.ENABLE_ASGARDEO_V2;

export const asgardeoFreeTierUuid =
  window.__RUNTIME_CONFIG__.ASGARDEO_FREE_TIER_UUID;

export const developerTierUuid = window.__RUNTIME_CONFIG__.DEVELOPER_TIER_UUID;

export const developerPaidTierUuid =
  window.__RUNTIME_CONFIG__.DEVELOPER_PAID_TIER_UUID;

export const enterpriseTierUuid =
  window.__RUNTIME_CONFIG__.ENTERPRISE_TIER_UUID;

export const teamWithSupportTierUuid =
  window.__RUNTIME_CONFIG__.TEAM_WITH_SUPPORT_TIER_UUID;

export const teamTierUuid = window.__RUNTIME_CONFIG__.TEAM_TIER_UUID;

export const oldPayAsYouGoTierUuid =
  window.__RUNTIME_CONFIG__.OLD_PAY_AS_YOU_GO_TIER_UUID;

export const stepBasedPayAsYouGoTierUuid =
  window.__RUNTIME_CONFIG__.STEP_BASED_PAY_AS_YOU_GO_TIER_UUID;

export const stepBasedSupportTierUuid =
  window.__RUNTIME_CONFIG__.STEP_BASED_SUPPORT_TIER_UUID;

export const stepBasedEnterpriseTierUuid =
  window.__RUNTIME_CONFIG__.STEP_BASED_ENTERPRISE_TIER_UUID;

export const enableInfraCost = window.__RUNTIME_CONFIG__.ENABLE_INFRA_COST;

export const disableLoginPage = window.__RUNTIME_CONFIG__.DISABLE_LOGIN_PAGE;

export const bijiraStarterTierUuid =
  window.__RUNTIME_CONFIG__.BIJIRA_STARTER_TIER_UUID;
export const bijiraPayAsYouGoTierUuid =
  window.__RUNTIME_CONFIG__.BIJIRA_PAY_AS_YOU_GO_TIER_UUID;

export const bijiraEnterpriseTierUuid =
  window.__RUNTIME_CONFIG__.BIJIRA_ENTERPRISE_TIER_UUID;

export const bijiraSupportTierUuid =
  window.__RUNTIME_CONFIG__.BIJIRA_SUPPORT_TIER_UUID;

export const devantPayAsYouGoTierUuid =
  window.__RUNTIME_CONFIG__.DEVANT_PAY_AS_YOU_GO_TIER_UUID;

export const devantStarterTierUuid =
  window.__RUNTIME_CONFIG__.DEVANT_STARTER_TIER_UUID;

export const devantEnterpriseTierUuid =
  window.__RUNTIME_CONFIG__.DEVANT_ENTERPRISE_TIER_UUID;

export const devantSupportTierUuid =
  window.__RUNTIME_CONFIG__.DEVANT_SUPPORT_TIER_UUID;

export const enableFreeTrial = window.__RUNTIME_CONFIG__.ENABLE_FREE_TRIALS;

export const freeTrialTierUuid = window.__RUNTIME_CONFIG__.FREE_TRIAL_TIER_UUID;

export const bijiraFreeTrialTierUuid =
  window.__RUNTIME_CONFIG__.BIJIRA_FREE_TRIAL_TIER_UUID;
export const bijiraReadOnlyTierUuid =
  window.__RUNTIME_CONFIG__.BIJIRA_READ_ONLY_TIER_UUID;
